import { Fragment, useEffect, useRef, useState } from 'react';
import logoCCBJI from "@/assets/img/2800_CCBJI_Logo.bmp";
import logoFVJ from "@/assets/img/2801_FVJ_Logo.bmp";
import { Link, useNavigate } from 'react-router-dom';
// SCN015

const ForgotPasswordPageInvalidUrl = () => {
    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    // Handler: Navigate to login page when logo is clicked
    const backToLogin = () => navigate('/login');

    // Render UI for expired/invalid token
    return (
        <Fragment>
            <nav className="navbar navbar-expand-lg navbar-light justify-content-start bg-white p-0" >
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item d-flex justify-content-around" onClick={backToLogin} style={{ height: '71px' }}>
                        <img className="m-1" src={logoCCBJI} alt="Logo 1" style={{ height: '90%' }} />
                        <img className="m-1" src={logoFVJ} alt="Logo 1" style={{ height: '90%' }} />
                    </li>
                </ul>
            </nav >
            <div className="container-fluid background-cover-external">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item active">パスワード再設定リンク期限切れ</li>
                </ol>
                <div className="jumbotron">
                    <div className="section">
                        <div className="card-body" style={{ minHeight: '45vh' }}>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                    <p>
                                        <span className='text-coca'>リンクが無効または期限切れです。</span>
                                    </p>
                                    <p><Link className="text-primary" to="/login"><u>ログイン</u></Link>からパスワードリセットをやり直してください。</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default ForgotPasswordPageInvalidUrl;
